import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingsService } from 'src/app/services/settings.service';
import { findFirstNonEmptyString } from '../../utils';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatLabel, MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { PasswordCreatedComponent } from '../password-created/password-created.component';

@Component({
  selector: 'frmg-invite-page',
  templateUrl: './invite-page.component.html',
  styleUrls: ['./invite-page.component.scss'],
  imports: [ReactiveFormsModule, FormsModule, MatLabel, MatFormField, MatInput, MatSuffix, NgClass, MatButton, PasswordCreatedComponent]
})
export class InvitePageComponent implements OnInit {
  inviteHash: string = '';
  password: string = '';
  confirmPassword: string = '';
  hidePassword: boolean = true;
  passwordCreatedSuccess = false;
  error: string;

  constructor(
    private route: ActivatedRoute,
    private settingsService: SettingsService
  ) {

  }

  ngOnInit(): void {
    this.inviteHash = this.route.snapshot.paramMap.get('invite-hash') || '';
  }

  createPassword(): void {
    // pick up the userid per the hash
    this.settingsService.retrieveUserId(this.inviteHash)
      .subscribe(invite => {
        this.settingsService.acceptInvitation(invite.email, this.inviteHash, this.password)
          .subscribe(
            {
              next: () => {
                this.passwordCreatedSuccess = true;
              },
              error: (error) => {
                this.error =  findFirstNonEmptyString(error.error);
              }
            }

          );
      }, (error) => {
        this.error =  findFirstNonEmptyString(error.error);
      });
  }

  hideError() {
    this.error = null;
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }
}
